// IssuesPanel.jsx — right-sidebar readiness checklist for the campaign editor
//
// Replaces the flat "Fix before scheduling" yellow blob that used to sit
// above the Cancel/Save/Schedule buttons. Each check has an explicit
// severity — pass (green ✓), warning (amber ▲), error (red ●) — so a
// marketer can scan and see exactly what's missing at a glance.
//
// Errors block the Schedule button; warnings do not. Same validation
// content as before, just categorized + visually laid out.
import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { CheckCircle2, AlertCircle, AlertTriangle } from 'lucide-react';

const SEV = {
  pass:    { color: '#28a745', Icon: CheckCircle2 },
  warning: { color: '#f0ad4e', Icon: AlertTriangle },
  error:   { color: '#dc3545', Icon: AlertCircle },
};

const IssuesPanel = ({ checks }) => {
  if (!checks || !checks.length) return null;
  const errorCount = checks.filter(c => c.status === 'error').length;
  const warnCount = checks.filter(c => c.status === 'warning').length;

  const headline = errorCount > 0
    ? { text: `${errorCount} thing${errorCount > 1 ? 's' : ''} to fix before scheduling`, color: '#dc3545' }
    : warnCount > 0
      ? { text: `Ready — ${warnCount} suggestion${warnCount > 1 ? 's' : ''}`, color: '#f0ad4e' }
      : { text: 'Ready to schedule', color: '#28a745' };

  return (
    <Card className="mb-3">
      <CardBody>
        <div style={{ fontWeight: 600, color: headline.color, marginBottom: 12, fontSize: 14 }}>
          {headline.text}
        </div>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {checks.map(c => {
            const { color, Icon } = SEV[c.status] || SEV.pass;
            return (
              <li
                key={c.id}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 8,
                  padding: '6px 0',
                  borderTop: '1px solid #f0f2f5',
                }}
              >
                <span style={{ color, flexShrink: 0, paddingTop: 1 }}>
                  <Icon size={16} />
                </span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, color: '#32325d', lineHeight: 1.35 }}>{c.label}</div>
                  {c.detail && (
                    <div style={{ fontSize: 11.5, color: '#8898aa', marginTop: 2 }}>{c.detail}</div>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </CardBody>
    </Card>
  );
};

export default IssuesPanel;
